module.exports = __webpack_public_path__ + "static/media/expand-from-corner.56897281.svg";